import styled from "styled-components";
import Subhead from "metabase/components/type/Subhead";

export const GreetingTitle = styled(Subhead)`
  margin-left: 1rem;
`;

export const GreetingContent = styled.div`
  display: flex;
  align-items: center;
`;
